import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import updateWorkoutAction from '../update'
import WORKOUTS_ACTION from '../../constants/action'
import { createISOStrDateUtil } from 'packages/src'

function updateLoggedAtWorkoutAction (params = {}) {
  return updateWorkoutAction({
    type: WORKOUTS_ACTION.UPDATE_LOGGED_AT,
    payload: {
      key: WORKOUT_KEY.LOGGED_AT,
      value: params.value || createISOStrDateUtil(),
      id: params.id
    }
  })
}

export default updateLoggedAtWorkoutAction
